export default Object.freeze({
  PDF: 'pdf',
  Word: 'word',
});
